import { FetchClient } from '../types'
import { PartnerEventPayload } from './types'

const URL = `/api/truework-js/monitoring/`

export const eventEndpoints = (fetchClient: FetchClient) => {
  return {
    async sendPartnerEvent(payload: PartnerEventPayload) {
      return fetchClient(URL, { method: 'POST', body: JSON.stringify({ ...payload, sent_at: new Date() }) })
    },
  }
}
